import React from 'react';
import { Drawer } from '@mantine/core';
import { NavLink } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthProvider';
import classes from './sidebar.module.scss';

export interface SidebarProps {
  isMobileOpen?: boolean;
  onMobileClose?: () => void;
}

export const Sidebar: React.FC<SidebarProps> = ({ isMobileOpen = false, onMobileClose }) => {
  const { user, selectedTenantId } = useAuth();
  const isSuperAdmin = user?.role === 'super_admin';
  const backofficePath = selectedTenantId ? `/t/${selectedTenantId}/backoffice` : '/home';

  const linkClass = ({ isActive }: { isActive: boolean }) =>
    isActive ? classes.activeLink : classes.link;

  const handleNavClick = () => {
    if (onMobileClose) onMobileClose();
  };

  const navItems = (
    <>
      <NavLink to={backofficePath} className={linkClass} onClick={handleNavClick} data-testid="sidebar-link-backoffice">
        {'בית'}
      </NavLink>
      {isSuperAdmin && (
        <>
          <NavLink to="/users" className={linkClass} onClick={handleNavClick} data-testid="sidebar-link-users">
            {'משתמשים'}
          </NavLink>
          <NavLink to="/tenants" className={linkClass} onClick={handleNavClick} data-testid="sidebar-link-tenants">
            {'חברות'}
          </NavLink>
          <NavLink to="/terminals" className={linkClass} onClick={handleNavClick} data-testid="sidebar-link-terminals">
            {'מסופי אשראי'}
          </NavLink>
          <NavLink to="/monitoring" className={linkClass} onClick={handleNavClick} data-testid="sidebar-link-monitoring">
            {'מעקב'}
          </NavLink>
          <NavLink to="/maintenance" className={linkClass} onClick={handleNavClick} data-testid="sidebar-link-maintenance">
            {'תחזוקה'}
          </NavLink>
        </>
      )}
    </>
  );

  return (
    <>
      <aside className={classes.sidebar}>
        <nav>{navItems}</nav>
      </aside>
      <Drawer
        opened={isMobileOpen}
        onClose={onMobileClose ?? (() => undefined)}
        position="right"
        size="220px"
        withCloseButton={false}
        classNames={{ inner: classes.drawerInner, content: classes.drawerContent, header: classes.drawerHeader, body: classes.drawerBody }}
        withinPortal
      >
        <nav className={classes.drawerNav}>{navItems}</nav>
      </Drawer>
    </>
  );
};
